export const VERMITTLER_ID = '00R7RW'

export const BASE_URL = 'https://www.maklerinfo.biz/rechner/bd'

export type Rechner = {
  id: string
  label: string
  category: string
  description?: string
}

export const RECHNER: Rechner[] = [
  { id: 'ambulantzusatz', label: 'Ambulantzusatz', category: 'Kranken' },
  {
    id: 'bauherrenhaftpflicht',
    label: 'Bauherrenhaftpflicht',
    category: 'Sach / Haftpflicht',
  },
  {
    id: 'berufshaftpflichtaerzte',
    label: 'Berufshaftpflicht für Ärzte',
    category: 'Gewerbe',
  },
  {
    id: 'betriebshaftpflicht',
    label: 'Betriebshaftpflicht',
    category: 'Gewerbe',
  },
  { id: 'rechtsschutzfirma', label: 'Firmenrechtsschutz', category: 'Gewerbe' },
  {
    id: 'gewaesserschadenhaftpflicht',
    label: 'Gewässerschadenhaftpflicht',
    category: 'Sach / Haftpflicht',
  },
  { id: 'glasbruch', label: 'Glasbruch', category: 'Sach' },
  {
    id: 'hausundgrundstueckshaftpflicht',
    label: 'Haus- und Grundbesitzerhaftpflicht',
    category: 'Immobilie',
  },
  { id: 'hausrat', label: 'Hausrat', category: 'Immobilie' },
  { id: 'hundehaftpflicht', label: 'Hundehaftpflicht', category: 'Tier' },
  { id: 'krankentagegeld', label: 'Krankentagegeld', category: 'Kranken' },
  { id: 'pferdehaftpflicht', label: 'Pferdehaftpflicht', category: 'Tier' },
  { id: 'privatepkw', label: 'PKW (privat)', category: 'KFZ' },
  {
    id: 'privathaftpflicht',
    label: 'Privathaftpflicht',
    category: 'Sach / Haftpflicht',
  },
  { id: 'rechtsschutz', label: 'Rechtsschutz', category: 'Sach / Haftpflicht' },
  { id: 'stationaerzusatz', label: 'Stationärzusatz', category: 'Kranken' },
  { id: 'sterbegeld', label: 'Sterbegeld', category: 'Vorsorge' },
  { id: 'tierkv', label: 'Tierkranken', category: 'Tier' },
  { id: 'unfall', label: 'Unfall', category: 'Vorsorge' },
  { id: 'wohngebaeude', label: 'Wohngebäude', category: 'Immobilie' },
  { id: 'zahnzusatz', label: 'Zahnzusatz', category: 'Kranken' },
  {
    id: 'krankenvoll',
    label: 'Private Krankenversicherung',
    category: 'Kranken',
  },
  { id: 'inventar', label: 'Inventarversicherung', category: 'Gewerbe' },
  {
    id: 'vermoegenschadenhaftpflicht',
    label: 'Vermögensschadenhaftpflicht',
    category: 'Gewerbe',
  },
  {
    id: 'gewerbeelektronik',
    label: 'Gewerbliche Elektronik',
    category: 'Gewerbe',
  },
]

export const RECHNER_BY_ID = Object.fromEntries(
  RECHNER.map((r) => [r.id, r]),
) as Record<string, Rechner>

export function buildRechnerUrl(rechnerId: string) {
  return `${BASE_URL}/${VERMITTLER_ID}/${rechnerId}`
}

// Kategorien mit Farben und Icons
export const CATEGORIES = [
  { name: 'Kranken', color: 'red', icon: 'Heart' },
  { name: 'Sach / Haftpflicht', color: 'blue', icon: 'ShieldAlert' },
  { name: 'Sach', color: 'slate', icon: 'Shield' },
  { name: 'Gewerbe', color: 'purple', icon: 'Building2' },
  { name: 'Immobilie', color: 'green', icon: 'Home' },
  { name: 'Tier', color: 'amber', icon: 'PawPrint' },
  { name: 'KFZ', color: 'indigo', icon: 'Car' },
  { name: 'Vorsorge', color: 'pink', icon: 'Umbrella' },
] as const

export function getRechnerByCategory() {
  const grouped: Record<string, Rechner[]> = {}

  RECHNER.forEach((rechner) => {
    if (!grouped[rechner.category]) {
      grouped[rechner.category] = []
    }
    grouped[rechner.category].push(rechner)
  })

  return grouped
}
